import { Image, Text, View } from '@react-pdf/renderer';
// eslint-disable-next-line no-restricted-imports
import { tv } from 'tailwind-variants';

import { tw } from '../pdf-tw';
import { commonStyles } from '../styles';
import { PdfLocation, PdfTenant } from '../types';

const styles = tv({
  slots: {
    header: 'flex-row justify-between text-textSecondary',
    logoContainer: 'shrink-0',
    clinicInfoContainer: 'w-1/2 text-right',
    logo: 'max-h-[48px] max-w-[120px] object-contain object-left',
    clinicName: 'text-right ' + commonStyles.bodyBold(),
  },
})();

export const LocationHeader: React.FC<{
  tenant: PdfTenant;
  location?: PdfLocation;
  showTaxId?: boolean;
}> = ({ tenant, location, showTaxId = false }) => {
  const clinicName =
    location?.businessName ??
    [tenant.name, location?.name].filter(Boolean).join(' - ');
  const logoUrl = location?.logoUrl;

  const locationInfoLines = [];
  if (location?.address) {
    locationInfoLines.push(location.address);
  }
  if (location?.phoneNumber) {
    locationInfoLines.push(`Tel: ${location.phoneNumber}`);
  }
  if (showTaxId && location?.taxId) {
    locationInfoLines.push(`Tax ID: ${location.taxId}`);
  }

  return (
    <View fixed style={tw(styles.header())}>
      <View style={tw(styles.logoContainer())}>
        {logoUrl && <Image style={tw(styles.logo())} src={logoUrl} />}
      </View>

      <View style={tw(styles.clinicInfoContainer())}>
        <View>
          <Text style={tw(styles.clinicName())}>{clinicName}</Text>
        </View>
        {Boolean(locationInfoLines.length) && (
          <View>
            {locationInfoLines.map((line, i) => {
              return (
                <Text key={i} style={tw(commonStyles.body())}>
                  {line}
                </Text>
              );
            })}
          </View>
        )}
      </View>
    </View>
  );
};
